import { ID as CAROUSEL_ID } from '../../website/widgets/dynamic/Carousel';
import { ID as PAY_ONLINE_ID } from '../../website/widgets/dynamic/PayOnline';

const allIds = [
  CAROUSEL_ID,
  PAY_ONLINE_ID,
];

const shouldWrapInAdmin = componentId => !allIds.includes(componentId);

export default shouldWrapInAdmin;
